/**
 * 处理数字三位数加逗号
 * @param num 数字
 * @returns
 */
export const thousands = (num: number) => {
  const str = num.toString();
  const reg = str.indexOf('.') > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
  return str.replace(reg, '$1,');
};

/**
 * 按照指定长度为数字前面补零
 * @param {number} num 数字
 * @param {number} length 期望输出长度
 * @returns
 */
export function prefixInteger(num, length) {
  return (Array(length).join('0') + num).slice(-length);
}
